import Modal from 'components/shared/Modal/Modal';

const preAuthRiderLink =
  'https://myriad-public.s3.us-east-1.amazonaws.com/25M11.5_Addendum_Pre-Authorized+Healthcare.pdf';

const PreAuthRiderView = ({ isOpen, handleClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      width="full"
      handleClose={handleClose}
      slideFromRight
      title="Pre-authorized healthcare transactions"
      bodyClassName="!p-0 overflow-hidden">
      <object data={preAuthRiderLink} type="application/pdf" className="h-full w-full">
        <div className="p-4">
          Unable to preview the rider PDF.
          <a
            href={preAuthRiderLink}
            target="_blank"
            rel="noopener noreferrer"
            className="ml-1 text-primary-600 underline">
            Open it in a new tab
          </a>
        </div>
      </object>
    </Modal>
  );
};

export default PreAuthRiderView;
